import { GetterTree } from "vuex";
import { ScoreState } from "../types";
import { IRootState, IRootGetters } from "../../types";
import { getPercentWhoDrinkLess } from "../getterRules/percentWhoDrinkLess";
import { IScoreGetters } from "./types";
import { GetterNames } from "./names";

export const getters: GetterTree<ScoreState, IRootState> = {
  [GetterNames.PERCENTWHODRINKLESS](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): number {
    const weeklyUnitsAndCalories = getters[GetterNames.WEEKLYUNITSANDCALORIES];
    const gender = rootGetters["profile/gender"];
    const drinkFrequency = rootGetters["drinking/drinkFrequency"];
    return getPercentWhoDrinkLess({
      gender,
      drinkFrequency,
      weeklyUnitsAndCalories
    });
  },
  [GetterNames.ORIGINALPERCENTWHODRINKLESS](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): number {
    const weeklyUnitsAndCalories =
      getters[GetterNames.ORIGINALWEEKLYUNITSANDCALORIES];
    const gender = rootGetters["profile/gender"];
    const drinkFrequency = rootGetters["drinking/drinkFrequency"];
    return getPercentWhoDrinkLess({
      gender,
      drinkFrequency,
      weeklyUnitsAndCalories
    });
  }
};
